<div #editorWrapper class="editor-wrapper" (mouseenter)="activateEditor()">
  @if (showLinkToolbar()) {
    <div class="link-toolbar" [ngStyle]="linkToolbarStyle" (mousedown)="$event.stopPropagation()">
      @if (isEditingLink()) {
        <div class="link-edit-inline">
          <ui-input
            #linkInput
            [compact]="true"
            [placeholder]="'Quill.Link.Placeholder' | translate"
            [(ngModel)]="linkInputUrl"
            (keydown.enter)="saveInlineLink()"
            (keydown.escape)="cancelInlineLink()"
          />
          <button mat-icon-button (click)="saveInlineLink()" [matTooltip]="'Global.Save' | translate">
            <mat-icon>check</mat-icon>
          </button>
          <button mat-icon-button (click)="cancelInlineLink()" [matTooltip]="'Global.Cancel' | translate">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      } @else {
        <a class="link-toolbar__url" [href]="activeLinkUrl" target="_blank">{{ activeLinkUrl }}</a>
        <button mat-icon-button (click)="startInlineLinkEdit()" [matTooltip]="'Quill.Link.Edit' | translate">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button (click)="removeLinkFromToolbar()" [matTooltip]="'Quill.Link.Remove' | translate">
          <mat-icon>link_off</mat-icon>
        </button>
      }
    </div>
  }
  @if (loading) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }

  <!-- Les différents types de input -->
  <div id="inputs">
    <div id="text-form">
      @if (chunkType === 'table') {
        <app-table-chunk-editor [(content)]="contentToSend" (contentChange)="onTableChange()" />
      } @else if (chunkType === 'latex') {
        <div class="latex-editor-container">
          <textarea
            cdkTextareaAutosize
            cdkAutosizeMinRows="1"
            cdkAutosizeMaxRows="20"
            class="latex-textarea w-100"
            [(ngModel)]="contentToSend"
            (ngModelChange)="onLatexChange()"
            [placeholder]="'CreateChunk.LaTeXPlaceholder' | translate"
            (keydown.control.enter)="submitChunk()"
            (keydown)="onTextareaKeyDown($event)"
          ></textarea>
        </div>
      } @else {
        @if (showQuill()) {
          <app-quill-toolbar
            [editor]="_editor"
            [showChunkOptions]="mode === 'modify-chunk' || mode === 'create-chunk'"
            [canUndo]="canUndo()"
            [canRedo]="canRedo()"
            (undo)="undo()"
            (redo)="redo()"
            (copy)="copyContentToClipBoard()"
            (convertToInlineFormula)="convertToInlineFormula()"
            (insertLink)="openLinkDialog()"
            [class.hidden]="!showToolbar()"
            [style]="toolbarStyle"
            [style.bottom]="(breakpointService.isSmallScreen() || breakpointService.isTabletScreen()) ? keyboardOffset() + 'px' : null"
            (mousedown)="$event.preventDefault()"
          />
          <quill-editor
            #mainQuillEditor
            (onEditorCreated)="onEditorCreated($event)"
            (keydown)="onEditorKeyDown($event)"
            (onSelectionChanged)="onSelectionChanged($event)"
            (onBlur)="isEditorFocused.set(false)"
            (paste)="onPaste($event)"
            [(ngModel)]="contentToSend"
            [modules]="quillModules"
            (onContentChanged)="onTypedText($event)"
            [placeholder]="'CreateChunk.Placeholder' | translate"
            class="full-width"
          />
        } @else {
          <quill-editor #secondaryQuillEditor [modules]="readOnlyQuillModules" [(ngModel)]="contentToSend" class="full-width" [placeholder]="'CreateChunk.Placeholder' | translate" />
        }
      }

      @if (submitMessage) {
        <p class="error-message" [ngClass]="submitMessage.type">
          {{ submitMessage.message }}
        </p>
      }
    </div>
  </div>
</div>
